document.addEventListener("turbo:load", function () {
  // Create and append the script
  const script = document.createElement("script");
  script.id = "google-translate-script";
  script.src = "https://translate.google.com/translate_a/element.js?cb=window.googleTranslate.googleTranslateElementInit";
  script.dataset.turbo_track = 'reload';
  script.async = true;
  document.head.appendChild(script);

  const dropdownBtn = document.getElementById("google-translate-btn");
  const dropdownMenu = document.getElementById("google-translate-dropdown");

  if (dropdownBtn && dropdownMenu) {
    dropdownBtn.removeEventListener("click", googleTranslate.toggleDropdown);
    dropdownBtn.addEventListener("click", googleTranslate.toggleDropdown);
  }

  if (window.googleTranslate) {
    window.googleTranslate.syncFlagWithCookie();
  }
});

class GoogleTranslateController {
  toggleDropdown() {
    document.getElementById("google-translate-dropdown").classList.toggle("hidden");
  }

  changeLanguage(lang, flag) {
    if (lang === 'ro') {
      this.resetTranslation();
    } else {
      const select = document.querySelector('select.goog-te-combo');
      if (select) {
        select.value = lang;
        select.dispatchEvent(new Event('change'));
      }

      const flagImgs = document.querySelectorAll("#current-flag");
      flagImgs.forEach(flagImg => {
        flagImg.src = `https://flagcdn.com/${flag}.svg`;
      });
    }
  }

  resetTranslation() {

    if (window.googleTranslator) {
      let restored = false;
      Object.keys(window.googleTranslator).forEach((key) => {
        if (restored) return;
        const translator = window.googleTranslator[key];
        if (typeof translator?.restore === 'function') {
          translator.restore();
          restored = true;
        }
      });
    }

    const hostname = window.location.hostname;
    const domains = [
      hostname, // current, e.g. valeajiului.eu
      `.${hostname}`, // dot prefix
      hostname.split('.').slice(-2).join('.'), // root, e.g. valeajiului.eu
      `.${hostname.split('.').slice(-2).join('.')}` // dot root, e.g. .valeajiului.eu
    ];

    document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;

    domains.forEach(d => {
      document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${d}`;
    });


    const flagImgs = document.querySelectorAll("#current-flag");
    flagImgs.forEach(flagImg => {
      flagImg.src = "https://flagcdn.com/ro.svg";
    });

    googleTranslate.hideTranslateBar();
  }

  googleTranslateElementInit() {
    window.googleTranslator = new google.translate.TranslateElement({
      pageLanguage: 'ro', // Default page language
      includedLanguages: 'ro,en,fr,de,es,it,hu', // Include Romanian as well
      layout: google.translate.TranslateElement.InlineLayout.HORIZONTAL,
    }, 'google_translate_element');
  }

  hideTranslateBar() {
    const style = document.createElement('style');
    style.innerHTML = `
      .goog-te-banner-frame.skiptranslate {
        display: none !important;
      }
      iframe.skiptranslate {
        visibility: hidden !important;
      }
      body {
        top: 0px !important;
      }
    `;
    document.head.appendChild(style);
  }

  syncFlagWithCookie() {
    const cookies = document.cookie.split('; ');
    const translateCookie = cookies.find(row => row.trim().startsWith('googtrans='));

    if (translateCookie) {
      let value = translateCookie.split('=')[1];

      value = decodeURIComponent(value);
      const matches = value.match(/\/(\w+)\/(\w+)/);

      if (matches && matches[2]) {
        const targetLang = matches[2];

        let flag = 'ro';
        if (targetLang === 'en') {
          flag = 'us';
        } else if (targetLang === 'ro') {
          flag = 'ro';
        }

        const flagImgs = document.querySelectorAll("#current-flag");
        flagImgs.forEach(flagImg => {
          flagImg.src = `https://flagcdn.com/${flag}.svg`;
        });
      }
    }
  }
}

window.googleTranslate = new GoogleTranslateController();
